import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: '',
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(["../components/login.vue"], resolve)
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(["../components/register.vue"], resolve)
    },
    {
      path: '/weChart',
      name: 'weChart',
      component: resolve => require(["../components/weChart.vue"], resolve)
    },
    {
      path: '/wechartProductList',
      name: 'wechartProductList',
      component: resolve => require(["../components/wechartProductList.vue"], resolve)
    },
    
    {
      path: '/manage',
      name: 'manage',
      redirect: '/home',
      meta: {
        requireAuth: true
      },
      component: resolve => require(["../components/manage.vue"], resolve),
      children: [
        {
          path: '/home',
          name: '资源管理',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/home.vue"], resolve)
        },
        {
          path: '/uploadPassword',
          name: '修改密码',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/uploadPassword.vue"], resolve)
        },
        {
          path: '/homeCopy',
          name: '首页管理',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/homeCopy.vue"], resolve)
        },
        {
          path: '/organized',
          name: '组织管理',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/organized.vue"], resolve)
        },
        {
          path: '/casting',
          name: '角色管理',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/casting.vue"], resolve)
        },
        {
          path: '/personnel',
          name: '人员管理',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/personnel.vue"], resolve)
        },
        {
          path: '/masterData',
          name: '经销商主数据管理',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/masterDataIndex.vue"], resolve)
        },
        {
          path: '/salesManagement',
          name: '经销商客户对照维护',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/salesManagement/masterDataIndex.vue"], resolve)
        },
        {
          path: '/clientMasterData',
          name: '客户主数据管理',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/clientMasterData.vue"], resolve)
        },
        {
          path: '/dictionariesAuthorization',
          name: '经销商授权维护',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/dictionariesAuthorization.vue"], resolve)
        },
        {
          path: '/salesHospital',
          name: '销售人员与医院关系维护',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/salesHospital.vue"], resolve)
        },
        {
          path: '/dictionaries',
          name: '系统字典管理',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/dictionaries.vue"], resolve)
        },
        {
          path: '/dealerTarget',
          name: '经销商指标维护',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/dealerTarget.vue"], resolve)
        },
        {
          path: '/product',
          name: '产品主数据维护',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/product.vue"], resolve)
        },
        {
          path: '/productPrice',
          name: '产品价格维护',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/productPrice.vue"], resolve)
        },
        {
          path: '/inStorage',
          name: '经销商采购入库',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/inStorage.vue"], resolve)
        },
        {
          path: '/priceScheme',
          name: '价格采购',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/masterData/priceScheme.vue"], resolve)
        },
        {
          path: '/setWareHouse',
          name: '仓库设定',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/setWareHouse.vue"], resolve)
        },
        {
          path: '/monthEnd',
          name: '月末库存上传',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/monthEnd.vue"], resolve)
        },
        {
          path: '/monthEndCopy',
          name: '月末库存上传',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/monthEndCopy.vue"], resolve)
        },
        {
          path: '/immediately',
          name: '即时库存查询',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/immediately.vue"], resolve)
        },
        {
          path: '/monthStart',
          name: '期初库存导入',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/monthStart.vue"], resolve)
        },
        {
          path: '/wareHouseManagement',
          name: '库存调整',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/wareHouseManagement.vue"], resolve)
        },
        {
          path: '/wareHouseMoveCheck',
          name: '库存调整审批',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/wareHouseMoveCheck.vue"], resolve)
        },
        {
          path: '/AddwareHouseMoveCheck',
          name: '发起库存调整审批',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/AddwareHouseMoveCheck.vue"], resolve)
        },
        {
          path: '/submitWareHouseMoveCheck',
          name: '库存调整审批提交',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/submitWareHouseMoveCheck.vue"], resolve)
        },
        {
          path: '/wareHouseMoveInfo',
          name: '库存调整审批详细',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/wareHouseMoveInfo.vue"], resolve)
        },
        {
          path: '/wareHouseMove',
          name: '经销商移库',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/warehouse/wareHouseMove.vue"], resolve)
        },
        {
          path: '/salerOutstore',
          name: '销量上报及导入',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/saleManage/salerOutstore.vue"], resolve)
        },
        {
          path: '/saleManageList',
          name: '销售明细查询',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/saleManage/saleManageList.vue"], resolve)
        },
        {
          path: '/marketNum',
          name: '销售汇总',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/saleManage/marketNum.vue"], resolve)
        },
        {
          path: '/outWarehouse',
          name: '出库单查询',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/saleManage/outWarehouse.vue"], resolve)
        },
        {
          path: '/inMsgEquipment',
          name: '设备信息导入',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/equipmentList/inMsgEquipment.vue"], resolve)
        },
        {
          path: '/inMsgEquipmentList',
          name: '设备管理查询',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/equipmentList/inMsgEquipmentList.vue"], resolve)
        },
        {
          path: '/wareList',
          name: '客户新建申请列表',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/saleManage/wareList.vue"], resolve)
        },
        {
          path: '/AddwareList',
          name: '客户新建申请审批',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/saleManage/AddwareList.vue"], resolve)
        },
        {
          path: '/wareListInfo',
          name: '客户新建申请详情',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/saleManage/wareListInfo.vue"], resolve)
        },
        {
          path: '/submitAddwareList',
          name: '客户新建申请提交',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/saleManage/submitAddwareList.vue"], resolve)
        },
        {
          path: '/inputSelectTree',
          name: '组织tree',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../common/inputSelectTree.vue"], resolve)
        },
        {
          path: '/messgaeList',
          name: '通知公告维护',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/home/messgaeList.vue"], resolve)
        },
        {
          path: '/messgaeQuestionList',
          name: '常见问题维护',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/home/messgaeQuestionList.vue"], resolve)
        },
        {
          path: '/appealSuggest',
          name: '申诉与反馈',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/home/appealSuggest.vue"], resolve)
        },
        {
          path: '/downloadFile',
          name: '文档下载',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/home/downloadFile.vue"], resolve)
        },
        {
          path: '/reportYTD',
          name: 'YTD医院设备产出报表',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/report/reportYTD.vue"], resolve)
        },
        {
          path: '/reportSummaryOfTerminalReagentFlowByDealer',
          name: '终端试剂流向汇总表(经销商)',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/report/reportSummaryOfTerminalReagentFlowByDealer.vue"], resolve)
        },
        {
          path: '/reportSummaryOfTerminalReagentFlow',
          name: '终端试剂流向汇总表',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/report/reportSummaryOfTerminalReagentFlow.vue"], resolve)
        },
        {
          path: '/reportDetailsOfTerminalReagentFlow',
          name: '终端试剂流向明细表',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/report/reportDetailsOfTerminalReagentFlow.vue"], resolve)
        },
        {
          path: '/reportPurchaseSalesInventory',
          name: '进销存报表',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/report/reportPurchaseSalesInventory.vue"], resolve)
        },
        {
          path: '/reportReagentTrend',
          name: '库存趋势图',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/report/reportReagentTrend.vue"], resolve)
        },
        {
          path: '/reportInventoryAdjustmentDetails',
          name: '库存调整明细表',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/report/reportInventoryAdjustmentDetails.vue"], resolve)
        },
        
        
        {
          path: '/onLineOrder',
          name: '网上订货单',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/orderManage/onLineOrder.vue"], resolve)
        },
        {
          path: '/agencyOnLineOrder',
          name: '代下订货单',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/orderManage/agencyOnLineOrder.vue"], resolve)
        },
        {
          path: '/onLineOrderError',
          name: '订货单接口异常',
          meta: {
            requireAuth: true
          },
          component: resolve => require(["../components/orderManage/onLineOrderError.vue"], resolve)
        },
      ]
    },
    
  ]
})
router.beforeEach((to, from, next) => {
  if (to.path) {
    window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
  }
  // 判断该路由是否需要登录权限
  if (to.meta.requireAuth) {
    // 判断是否是登录状态
    if (sessionStorage.canLogin) {
      next()
    } else {
      // 否则跳回登录页
      next('/')
    }
  } else {
    // 如果不需要登录权限，就直接resolve这个钩子
    next()
  }
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js